<template>
  <div class="device-doorlock">
    <div class="flex-row flex-nowrap page-search-block">
      <el-form :model="filters.search" label-width="90px" label-position="right">
        <el-form-item prop="deviceCode" label="设备编码：">
          <el-input v-model="filters.search.deviceCode" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item prop="electricity" label="电量：">
          <el-select v-model="filters.search.electricity" clearable placeholder="请选择">
            <el-option v-for="item in selOptions.range" :key="'dd_' + item.name" :label="item.value" :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="onlineStatus" label="在线状态：">
          <el-select v-model="filters.search.onlineStatus" clearable placeholder="请选择">
            <el-option key="fsdfs11" label="在线" :value="1"></el-option>
            <el-option key="fsdfs22" label="离线" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="curActiveTab == '104'" label="TF卡状态：">
          <el-select v-model="filters.search.tfCardStatus" placeholder="请选择" clearable>
            <el-option key="fsdfs11" label="正常" :value="0"></el-option>
            <el-option key="fsdfs22" label="卡不存在" :value="1"></el-option>
            <el-option key="fsdfs11" label="卡格式错误" :value="2"></el-option>
            <el-option key="fsdfs22" label="卡只读" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <div class="search-wrap-block">
          <el-button size="mini" type="primary" icon="Search" @click="handleSearch()">搜 索</el-button>
          <el-button size="mini" type="primary" icon="RefreshRight" @click="resetFilter()">重 置</el-button>
        </div>
      </el-form>
    </div>

    <RCell :title="tabsArr" ref="tabs" type="cellTop" class="edit-title cell-top" :tabActive="curActiveTab" @on-tab="handleTabClick">
    </RCell>

    <r-table
      :ref="tableVarity"
      :columns="tableColumn"
      :dataSource="tableData"
      :options="options"
      :pagination="pagination"
      @current-change="handlePageChange"
      @row-click="handleRowClick"
    ></r-table>
  </div>
</template>

<script>
import RTable from '@/components/common/RTable'
import tableMix from '@/components/common/tableListMixin.js'
import checkMix from '@/components/common/checkAll.js'
import { mapActions } from 'vuex'

const EQUIPMENT_TYPE = 103 // 设备类型：门锁

export default {
  name: 'equipDoorlock',
  mixins: [tableMix, checkMix],
  components: { RTable },
  data() {
    return {
      perms: [],

      curActiveTab: '103',
      tabsArr: [
        { label: '门锁', name: '103' },
        { label: '门铃', name: '104' },
      ],

      // =================================================== 列表 table
      tableVarity: 'unauth-equip-table',
      tableColumn: [],
      tableData: [],
      detailData: {},
      options: {
        multiSelect: true, // 多选
        serialNum: false, // 显示序号
        loading: false, // 加载中状态
        initTable: true, // 是否一挂载就加载数据
        height: 'calc(100vh - 295px)',
        mutiSelect: true,
        selection: [],
      },
      pagination: {
        total: 0,
        pageIndex: 1,
        pageSize: 20,
      },
      // 查询参数
      filters: {
        search: {
          onlineStatus: '',
          electricity: '',
          deviceCode: '',
          tfCardStatus: '',
        },
      },
      selOptions: {
        onlineStatus: [
          { name: 0, value: '离线' },
          { name: 1, value: '在线' },
        ],
      },
    }
  },
  created() {
    this.perms = 'perms' in localStorage && localStorage.perms !== '' ? JSON.parse(localStorage.perms) : []
    this.initTableColumns()
    this.getDictData()
    this.getQuery()
  },
  mounted() {
    let curUnauthlistPageTab = localStorage.getItem('curUnauthlistPageTab')
    if (curUnauthlistPageTab != null) {
      this.curActiveTab = curUnauthlistPageTab
      this.$nextTick(() => {
        setTimeout(() => {
          this.getQuery()
        }, 300);
      })
    }
  },
  methods: {
    ...mapActions(['importUpload']),
    // 获取字典数据
    getDictData() {
      let url = 'RESOURCE.GET_MULTI_LIST'

      this.fetchData({
        url,
        method: 'get',
        params: {
          type: 'electricity_range',
          start: 0,
          size: 1000,
          toExcel: false,
        },
      }).then((res) => {
        this.selOptions.range = res.data
      })
    },
    // 初始化门锁自定义表头
    initTableColumns() {
      let columns = [
        { prop: 'deviceCode', label: '设备编码', visible: true, minWidth: 190 },
        { prop: 'deviceModel', label: '设备型号', visible: true, minWidth: 190 },
        { prop: 'onlineStatus', label: '在线状态', visible: true, minWidth: 130 },
        { prop: 'electricity', label: '电量', visible: true, minWidth: 120 },
        { prop: 'deviceVersion', label: '版本信息', visible: true, minWidth: 250 },
        { prop: 'mscs_name', label: '设备厂商', visible: true, minWidth: 100 },
        { prop: 'createTime', label: '创建时间', visible: true, minWidth: 160 },
        { prop: 'updateTime', label: '更新时间', visible: true, minWidth: 160 },
      ]

      let lockCol = [
        { prop: 'deviceImsi', label: 'IMSI', visible: true, minWidth: 130 },
        { prop: 'deviceIccid', label: 'ICCID', visible: true, minWidth: 130 },
      ]

      let bellCol = [{ prop: 'tfCardStatus', label: 'TF卡状态', visible: true, minWidth: 130 }]

      if (this.curActiveTab == '103') {
        columns.splice(4, 0, ...lockCol)
      } else {
        columns.splice(4, 0, ...bellCol)
      }

      columns.forEach((item) => {
        if (item.prop === 'mscs_name') {
          item.render = (row, index, column) => {
            return <div>瑞为技术</div>
          }
        }
        if (item.prop === 'tfCardStatus') {
          // 0=正常 1=卡不存在 2=卡格式错误 3=卡只读
          item.render = (row, index, column) => {
            let statuMap = { 0: '正常', 1: '卡不存在', 2: '卡格式错误', 3: '卡只读' }
            return <span>{statuMap[row[item.prop]]}</span>
          }
        }
        if (item.prop === 'onlineStatus') {
          item.render = (row, index, column) => {
            if (row.onlineStatus == 1) {
              return <span>在线</span>
            } else {
              return <span>离线</span>
            }
          }
        }
      })

      this.tableColumn = columns
    },
    // 显示日志详情
    handleShowDetail(row) {
      this.$emit('change-view', row)
    },
    // 获取查询参数
    getQueryParams() {
      let searches = {}
      for (let name in this.filters.search) {
        if (this.filters.search[name] === '') {
          continue
        }
        let searchParam = this.filters.search[name]
        if (name === 'onlineStatus' || name === 'targetStatus') {
          searchParam = Number(searchParam)
        }
        searches[name] = typeof searchParam === 'string' ? searchParam.trim() : searchParam
      }
      searches.deviceType = this.curActiveTab

      return {
        params: JSON.stringify(searches),
        start: (this.pagination.pageIndex - 1) * this.pagination.pageSize,
        size: this.pagination.pageSize,
        toExcel: false,
      }
    },
    // 查询列表数据
    getQuery() {
      this.options.loading = true
      let params = this.getQueryParams()

      let url = 'SAAS.GET_DEVICE_UNAUTH_LIST'
      this.fetchData({
        url,
        method: 'get',
        params,
      })
        .then((res) => {
          this.options.loading = false
          if (this.toExcel == true) {
            if (!res || !res.data) {
              this.$message.error('操作失败！')
            } else {
              window.location.href = res.data
            }
            this.toExcel = false
            return
          }

          if (!res || !res.data) {
            this.tableData = []
            this.pagination.total = 0
          } else {
            this.tableData = res.data || []
            this.pagination.total = res.count
          }
        })
        .catch((err) => {
          console.log(err, 'errorInfo')
        })
        .finally(() => {
          this.options.loading = false
          this.toExcel = false
        })
    },
    handleTabClick(tab) {
      this.curActiveTab = tab
      localStorage.setItem('curUnauthlistPageTab', tab) // 记录当前设备未授权名单页面选中的tab项，用途：刷新后恢复选中的tab
      this.initTableColumns()
      this.getQuery()
    },
  },
}
</script>

<style lang="less" scoped>
.table-item-btn {
  margin-right: 10px;
}
.page-search-block .el-form-item {
  width: 280px;
}
</style>
